import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.some.js";
import BillingService from '@/services/BillingService';
import CreditCardInfo from '@/components/creditcards/Info';
import CreditCardAddress from '@/components/creditcards/Address';
import CreditCardLogo from '@/components/creditcards/Logo';
import CreditCardDelete from '@/components/creditcards/Delete';
import CardModal from '@/components/account/CardModal';
export default {
  name: 'BillingList',
  components: {
    CardModal,
    CreditCardInfo,
    CreditCardAddress,
    CreditCardLogo,
    CreditCardDelete
  },
  props: {
    records: {
      type: Array,
      default() {
        return null;
      }
    },
    selected: {
      type: Object,
      default() {
        return null;
      }
    },
    address: {
      type: Object,
      default() {
        return null;
      }
    },
    states: Array,
    countries: Array
  },
  data: () => {
    return {
      loading: false,
      validated: false,
      billingrecords: null,
      cardaddress: null
    };
  },
  mounted() {
    this.init(false);
  },
  methods: {
    init(forceReload) {
      if (!this.cardaddress && this.address) {
        this.cardaddress = Object.assign({}, this.address);
      }
      if (this.records && !forceReload) {
        this.billingrecords = this.records;
        this.setBillingValidated();
        if (!this.cardaddress && this.billingrecords.length) {
          this.cardaddress = Object.assign({}, this.billingrecords[0].address);
        }
        this.autoSelectSingleCard();
      } else {
        this.loading = true;
        BillingService.init().then(response => {
          this.billingrecords = response.data.results;
          this.setBillingValidated();
          if (!this.cardaddress && this.billingrecords.length) {
            this.cardaddress = Object.assign({}, this.billingrecords[0].address);
          }
          this.autoSelectSingleCard();
        }).catch(error => {
          this.$aim.error(error.response);
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    setBillingValidated() {
      this.validated = false;
      this.billingrecords.some(r => {
        if (r.validated) {
          this.validated = true;
          return true;
        }
        return false;
      });
    },
    autoSelectSingleCard() {
      // Check if there is exactly one valid card
      const validCards = this.billingrecords.filter(r => +r.validated === 1 && +r.expvalid === 1);
      if (validCards.length === 1) {
        this.selectCreditCard(validCards[0]);
      }
    },
    setDefaultBilling(billing) {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      BillingService.default(billing.id).then(response => {
        this.$aim.notify(response);
        this.init(true);
      }).catch(error => {
        this.$aim.error(error.response);
      }).finally(() => {
        this.loading = false;
        this.init();
      });
    },
    selectCreditCard(billing) {
      this.$emit('select', billing);
    },
    bgClass(billing) {
      let output = 'alert alert-info';
      if (+billing.validated !== 1) {
        output = 'alert alert-danger';
      } else if (billing.daysexpire < 30) {
        output = 'alert alert-warning';
      } else if (+billing.expvalid === 0) {
        output = 'alert alert-danger';
      } else if (billing.default_payment_method) {
        output = 'alert alert-success';
      }
      return output;
    }
  },
  computed: {
    /**
     * @returns {Boolean}
     */
    isSelectMode() {
      return this.selected !== null;
    },
    /**
     * @returns {Boolean}
     */
    hasSelection() {
      return this.selected !== null && this.selected && this.selected.id > 0;
    }
  },
  filters: {
    billingType: function (value) {
      return value > 1 ? 'Annually' : value ? 'Monthly' : 'Once';
    }
  }
};